export default __webpack_public_path__ + "static/media/HacktoberYear.4fa815cb.png";